import styled from 'styled-components';

import {
  subMenuDropdownBackground
} from '../../config/colors';

export const LocationAndCraneCoverageWrapper = styled.div`
    display: flex;
    padding: 35px 30px 100px 30px;
    background-color: ${subMenuDropdownBackground};
    position: relative;
    justify-content: flex-end;

    @media print {
      background-color: white;
      padding: 20px 50px 20px 25px;
      height: 200px;

      img, div {
        height: 200px !important;
      }
    }
`;

